import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { c_alert_component } from './c_alert_component';

@NgModule({
  imports: [CommonModule],
  declarations: [c_alert_component],
  exports: [c_alert_component],
})
export class c_alert_module {}
